exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-de2925e0] {\n    max-width: 95% !important;\n    width: 95% !important;\n}\n", ""]);

// exports
